import React from "react";
import "../css/App.css";

export default function FooterSticky({ date }) {
  return (
    <footer className="footer">
      <p>
        Mise à jour du stock : <strong>{date || "—"}</strong>
      </p>
    </footer>
  );
}
